/* eslint-disable import/no-unresolved */
/* eslint-disable import/prefer-default-export */

import API_URLS from "src/config/API_URLS";
import axiosInstance from "src/utils/Axios/axiosInstance";

export const sendOtpToEmail = async (email: string, length = 6) => {
  try {
    const reqBody = { email, length };
    const response: any = await axiosInstance.post(API_URLS.sendEmailOtp, reqBody);
    return response;
  } catch (response: any) {
    throw new Error(
      response?.data?.error?.message || response?.message || "Failed to send OTP to email"
    );
  }
};

export const sendOtpToMobile = async (mobile: string, length = 6) => {
  try {
    const reqBody = { mobile, length };
    const response: any = await axiosInstance.post(API_URLS.sendEmailOtp, reqBody);
    return response;
  } catch (response: any) {
    throw new Error(
      response?.data?.error?.message || response?.message || "Failed to send OTP to mobile"
    );
  }
};

export const sendOtpToEmailAndMobile = async (email: string, mobile: string, length = 6) => {
  try {
    const reqBody = { email, mobile, length };
    const response: any = await axiosInstance.post(API_URLS.sendEmailOtp, reqBody);
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message || response?.message || "Failed to send OTP");
  }
};

export const validateOtp = async ({ id, otp }: { id: string; otp: number }) => {
  try {
    const reqBody = {
      id,
      otp
    };
    const response: any = await axiosInstance.post(API_URLS.validateEmailOtp, reqBody);
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message || response?.message || "Failed to verify OTP");
  }
};

const OtpService = {
  sendOtpToEmail,
  sendOtpToMobile,
  sendOtpToEmailAndMobile,
  validateOtp
};

export default OtpService;
